$('document').ready(function () {
    // Ask an Expert Form
    // update hidden Request type field with topic
    $('form#66b4c0a2-2e14-4557-86f9-9431dd965256 #802654c6-6d81-4f07-9ba3-412c2cec7966 input, form#66b4c0a2-2e14-4557-86f9-9431dd965256 #e638b4e6-70ff-49b0-8780-9bdb072e1da0 input').on('click', function () {
        $('.formcontainerblock form#66b4c0a2-2e14-4557-86f9-9431dd965256 input#a1378c4b-5690-4f75-93e0-4e84c0022cf7').val($(this).attr('value'))
    });

    // form submission handling
    if (typeof $$epiforms !== 'undefined') {
        $$epiforms(document).ready(function myfunction() {
            console.log('listen to event');
            $$epiforms(".EPiServerForms").on("formsSubmitted", function (event, param1, param2) {
                // scroll to top of form to view thank you message
                if ($('#webinar-link-details').length) {
                    // handle specific scrolling for webinars
                    $('#webinar-link-details').show();
                    $('.formcontainerblock').hide();
                    $('.webinar-info-register').hide();

                    $('html, body').animate({
                        scrollTop: $('#webinar-link-details').offset().top - 150
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: $('.form-section').offset().top
                    }, 500);
                }
            });
        });
    }

    // state / country Salesforce handling
    if (typeof __CountryStateMapping != 'undefined' && __CountryStateMapping != null) {
        var $countryTempOption = $("option[value='country_list']");
        var $countryField = $countryTempOption.parent();
        $countryTempOption.remove();
        var $stateTempOption = $("option[value='state_list']");
        var $stateField = $stateTempOption.parent();
        $stateTempOption.remove();


        var $firstOption = $stateField.find("option").eq(0).show();
        $stateField.empty();
        $stateField.append($firstOption);

        $countryField.on("change", function () {
            var countryValue = $(this).find("option:selected").text();
            $stateField.empty();
            $stateField.append($firstOption);
            $stateField.val($firstOption.val());

            var countryMapped = __CountryStateMapping[countryValue];

            if (countryMapped) {
                var states = countryMapped.States;
                var lastState = "";
                for (var stateName in states) {
                    var stateValue = states[stateName];
                    lastState = stateValue;
                    if (countryValue.toLowerCase() != stateValue.toLowerCase())
                        $stateField.append("<option value='" + states[stateValue] + "'>" + stateName + "</option>");
                }

                if (states != null && Object.keys(states).length == 1) {
                    $stateField.val(lastState);
                    $stateField.closest(".FormSelection").addClass('hide-imp');
                } else {
                    $stateField.closest(".FormSelection").removeClass('hide-imp');

                    if ($stateField.find("option").length == 2) {
                        $stateField.val($stateField.find("option").eq(1).val());
                    }
                }

            } else {
                $stateField.closest(".FormSelection").addClass('hide-imp');
            }
        });
    }
});